module.exports = __webpack_public_path__ + "img/b8.51d8ce54.jpg";